<template>
  <div class="wim-cover-section tva-row" >
    <div class="wim-cover-wrapper tva-col-xs-12 tva-col-sm-offset-3 tva-col-sm-8">
      <div class="wim-cover-image" >
        <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.image}${$retina ? '@2x' : ''}.jpg`" alt="image">
      </div>
    </div>

    <div class="wim-cover-title tva-col-xs-12 tva-col-sm-offset-1 tva-col-sm-6 ">
      <h2 v-html="content.title" :style="`padding-bottom: ${progress < .2 ? progress * 150 + 15 : progress > .8 ? scaleNegativeProgress(progress) : 0}%`">{{content.title}}</h2>
    </div>
  </div>
</template>
<script>
import {scaleLinear} from 'd3-scale';

export default {
  props: ["content", "progress"],
  methods: {
    scaleNegativeProgress(value) {
      let scale = scaleLinear().domain([.8,1]).range([0, 15]);
      return scale(value);
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.wim-cover-section {
  width: 100%;
  margin: 10vh 0;
  position: relative;
  .wim-cover-wrapper {
    position: relative;
    padding: 0;
    .wim-cover-image {
      width: 100%;
      height: 0;
      position: relative;
      padding-bottom: 66.66%;
      overflow: hidden;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }
  }
  .wim-cover-title {
    position:absolute;
    bottom: 0;
    left: 0%;
    z-index: 1;
    user-select: none;
    h2 {
      margin: 0;
      padding: 10% 0;
      font-size: 10vw;
      line-height: 12vw;
    }
    @media (min-width: 1360px) {
      h2 {
        font-size: 122px;
        line-height: 163px;
      }
    }
  }
}
@media(max-width:767px) {
  .wim-cover-section {
    margin: 40px 0 70px;
    padding:0;
    .wim-cover-image {
      height: 100%;
      width: 100%;
      padding: 0;
      overflow: visible;
      img {
        position: relative;
        object-fit: cover;
        height: 100%; 
        width: 100%; 
      } 
    }
    .wim-cover-title {
      width: 100%;
      padding:0;
      position:absolute;
      top:66%;
      left: -20px;
      h2 {
        line-height: 16vw;
        padding: 0 !important;
        font-size: 15vw;
      }
    }
  }
}
</style>